import { TOption } from '@src/types';
import { useMemo } from 'react';

export const useDisplayedProductsForTableAndChart = (
  products: TOption[],
  selectedProducts: string[]
) => {
  const selectedItemsForDisplay = useMemo(() => {
    return selectedProducts.length > 0
      ? products
          .filter((product) => selectedProducts.includes(product.value))
          .map((product) => product.label)
      : [];
  }, [products, selectedProducts]);

  return { selectedItemsForDisplay };
};
